import { useEffect, useState } from "react";

interface ForgotPasswordAgainCounterProps {
  count: number;
  setDisableCounter: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ForgotPasswordCounter = ({ count, setDisableCounter }: ForgotPasswordAgainCounterProps) => {
  const [counter, setCounter] = useState(count);

  const getMinutesSeconds = (time?: number) => {
    if (!time) {
      return "0";
    }
    const minutes = Math.floor(time / 60);
    const seconds = time - minutes * 60;
    return `${minutes < 10 ? `0${minutes}` : minutes} : ${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  useEffect(() => {
    if (counter <= 0) {
      setDisableCounter(false);
      return;
    }
    const timeout = setTimeout(() => setCounter(counter - 1), 1000);
    return () => clearTimeout(timeout);
  }, [counter, setDisableCounter]);

  return <>{getMinutesSeconds(counter)}</>;
};
